






import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Main extends Vue {
  constructor() {
    super();
  }
}
